import { mapCanBeSold } from "./mapCanBeSold";
import { mapCanBeSubscribed } from "./mapCanBeSubscribed";
export var mapHasAutoSubscription = function mapHasAutoSubscription(labels) {
  return !mapCanBeSold(labels) && mapCanBeSubscribed(labels);
};
//# sourceMappingURL=mapHasAutoSubscription.js.map